import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	CREATE_APPOINTMENT: {
		path: 'appointments',
		method: 'POST'
	}
};

export interface ICreateAppointmentOptions extends IBaseFetchOptions {
	body: {
		firstName: string;
		lastName: string;
		email: string;
		date: Date | string;
		storeId: string;
		phoneCode?: string;
		phone?: string;
		message?: string;
		reason?: string;
		country?: string;
		time?: string;
		city?: string;
	};
}

export interface ICreateAppointmentResponse extends IBaseResponse {
	confirmMessage: string;
}
